import { render } from "./petunjuk-soal-pilihan-ganda.vue?vue&type=template&id=3cd79d62&scoped=true"
import script from "./petunjuk-soal-pilihan-ganda.vue?vue&type=script&lang=js"
export * from "./petunjuk-soal-pilihan-ganda.vue?vue&type=script&lang=js"

import "./petunjuk-soal-pilihan-ganda.vue?vue&type=style&index=0&id=3cd79d62&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd79d62"]])

export default __exports__